// extracted by mini-css-extract-plugin
export default {"photo":"ProdutoFoto_photo__F4eHp"};